var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "feed-action-button"
  }, [!_vm.single ? [_vm._v(" - "), _c('a', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "title": "Update with MetaMask with MetaMask transaction"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.openUpdateModal.apply(null, arguments);
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-cloud-upload"
  }), _vm._v(" Send update tx ")])] : [_c('a', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "title": "Update feed with MetaMask transaction"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.openUpdateModal.apply(null, arguments);
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-cloud-upload"
  }), _vm._v(" Push on-chain update ")])], _c('UpdateFeedModal', {
    attrs: {
      "feed-data": _vm.item
    },
    on: {
      "update-success": _vm.handleUpdateSuccess,
      "update-error": _vm.handleUpdateError
    },
    model: {
      value: _vm.isUpdateModalVisible,
      callback: function callback($$v) {
        _vm.isUpdateModalVisible = $$v;
      },
      expression: "isUpdateModalVisible"
    }
  })], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }